// extracted by mini-css-extract-plugin
module.exports = {"container":"vM-z","recos":"wM-z","productCardOverride":"xM-z"};